"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.Title = exports.ProgressBar = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "lkxd3q-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n"])));

exports.Wrapper = Wrapper;

var ProgressBar = _styledComponents["default"].div.withConfig({
  displayName: "styled__ProgressBar",
  componentId: "lkxd3q-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n    height: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    overflow: hidden;\n    &:after {\n        display: block;\n        content: '';\n        height: 100%;\n        width: ", "%;\n        transition: 1s;\n        background-color: ", ";\n        border-radius: ", "px;\n    }\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.background;
}, function (p) {
  return p.borderRadius;
}, function (p) {
  return 100 * p.progress;
}, function (p) {
  return p.color;
}, function (p) {
  return p.borderRadius;
});

exports.ProgressBar = ProgressBar;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "styled__Title",
  componentId: "lkxd3q-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: block;\n    ", ";\n    margin-bottom: 10px;\n    color: ", ";\n    @media(max-width: 1080px) {\n        ", ";\n        margin-bottom: 8px;\n    }\n"])), _constants.FONTS.L, _constants.COLORS.black, _constants.FONTS.S);

exports.Title = Title;

var Description = _styledComponents["default"].div.withConfig({
  displayName: "styled__Description",
  componentId: "lkxd3q-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n    ", ";\n    color: ", ";\n    margin-top: 6px;\n    @media(max-width: 1080px) {\n        ", ";\n    }\n"])), _constants.FONTS.S, _constants.COLORS.grey, _constants.FONTS.XS);

exports.Description = Description;